import { render, staticRenderFns } from "./ListService.vue?vue&type=template&id=0c4240f4&scoped=true&"
import script from "./ListService.vue?vue&type=script&lang=js&"
export * from "./ListService.vue?vue&type=script&lang=js&"
import style0 from "./ListService.vue?vue&type=style&index=0&id=0c4240f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4240f4",
  null
  
)

export default component.exports